
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stream-extra-battery-series",
      function () {
        return require("private-next-pages/stream-extra-battery-series/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stream-extra-battery-series"])
      });
    }
  